
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import ScaffoldHeader from "@/components/scaffold/ScaffoldHeader.vue";
  import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
  import CardPagination from "@/components/card/CardPagination.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import ApplicationCard from "@/components/applications/ApplicationCardV2.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import { inviteContractors } from "@/services/inviteContractors";
  import Message from "@/data/notificationsMessages";
  import { NOTIFICATION } from "@/entities/Events";
  import belongsToCompany from "@/helpers/isContractorInCompany";

  import LIST_APPLICATIONS from "@/apollo/applications/ListApplicationsUsers.gql";
  import { Application, Application_Bool_Exp, Company, User } from "@/generated/graphql";
  import PaginationConfig from "@/entities/PaginationConfig";
  import paginationConfig from "@/data/paginationConfig";
  import { ApplicantStatus } from "@/entities/ApplicantStatus";
  import Roles from "@/entities/Roles";
  import EmptyListImageContractors from "@/components/icons/emptyListImages/EmptyListImageContractors.vue";
    import FormGroup from "@/components/form/FormGroupNew.vue";

  interface Conditions {
    offset: number;
    limit: number;
    companyId: string;
    where: {
      _and: any[]
    };
    totalActiveWhere: Application_Bool_Exp,
  }

  @Component({
    components: {
      EmptyListImageContractors,
      ScaffoldHeader,
      CardPagination,
      EmptyListPlaceholder,
      LoadingOverlay,
      ApplicationCard,
      UiButton,
      FormGroup
    },
    apollo: {
      applications: {
      query: LIST_APPLICATIONS,
        variables() {
          return this.conditions;
        },
        update(data) {
          //  sessionStorage.removeItem('isApplicants');
          const currentSessionValue = sessionStorage.getItem("isApplicants");

        let currentValue = currentSessionValue ? JSON.parse(currentSessionValue) : [];
        if (Array.isArray(currentValue) && currentValue.length === 0) {
           this.originalCount = data.total.aggregate.count;
          sessionStorage.setItem("isApplicants", JSON.stringify(data.total.aggregate.count));
        }
        else{
              this.originalCount = JSON.parse(currentSessionValue);
        }
          this.paginationConfig.total = data.total.aggregate.count;
          this.paginationConfig.loadedCount = data.application.length;
          this.totalActiveApplications = data.totalActive.aggregate.count;
          return data.application;
        },
      },
    },
  })
  export default class PostingApplications extends Vue {
    @Prop({ type: String, required: true }) readonly postingId!: string;
    @Prop({ type: String, required: true }) readonly jobTitle!: string;
    @Prop({ type: Boolean, default: false }) readonly review!: boolean;
    @Prop({ type: Boolean, default: false }) readonly approved!: boolean;
    @Prop({ type: Boolean, default: false }) readonly declined!: boolean;
    @Prop({ type: Boolean, default: false }) readonly cancelled!: boolean;
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    paginationConfig: PaginationConfig = { ...paginationConfig };
    applications?: Application[] = undefined;
    processing: boolean = false;
    originalCount: number = 0;
    totalActiveApplications: number = 0;
    searchText = '';

    @Watch("approved")
    @Watch("declined")
    @Watch("cancelled")
    @Watch("review")
    handleTotal(){
       sessionStorage.removeItem('isApplicants');
    }

    updated() {
      this.$emit('applicationCollectionUpdated', this.totalActiveApplications);
    }
    beforeUnmount(){
      sessionStorage.removeItem("isGroups");
    }

    get requestAllButtonText(): string {
      return this.isAdmin
        ? "Add All Approved Applicants"
        : "Request All Approved Applicants";
    }

    get showInviteAll(): boolean {
      if (this.isAdmin) {
        return this.approvedExternalContractorExists;
      }
      return (this.approvedExternalContractorExists || this.companyMemberToRequestExists);
    }

    get isAdmin(): boolean {
      return this.currentUser.role == Roles.ADMIN;
    }

    get conditions(): Conditions {
      const defaultConditions = [
        {
          posting_id: {
            _eq: this.postingId,
          },
        },

      ]

      const conditions: any[] = [];
      if (this.declined) {
        conditions.push({
           status: {
                _in: [ ApplicantStatus.DECLINED ]},
           is_cancelled: { _eq: false },
          })
        } else if (this.cancelled) {
          conditions.push({
            is_cancelled: { _eq: true }
          })
        }else if (this.approved) {
          conditions.push({
            status: { _eq: ApplicantStatus.APPROVED },
            is_cancelled: { _eq: false },
        })
      } else if (this.review) {
        conditions.push(
          { status: { _in: [
            ApplicantStatus.UNDER_REVIEW,
            ApplicantStatus.INTERVIEWED,
            ApplicantStatus.SEND_FOR_APPROVAL,
            ApplicantStatus.NOT_REVIEWED,
          ]},
          is_cancelled: { _eq: false }},
        )
      }else {
                conditions.push({ _or: [
            {
              status: {
                _in: [
                  ApplicantStatus.INTERVIEWED,
                  ApplicantStatus.APPROVED,
                  ApplicantStatus.SEND_FOR_APPROVAL,
                  ApplicantStatus.DECLINED,
                  ApplicantStatus.CANCELLED,
                  ApplicantStatus.UNDER_REVIEW,
                ]
              }
            },
            { _and: [
                { status: { _eq: ApplicantStatus.NOT_REVIEWED}},

              ]
            },
          ]
        })
      }
      if(!!this.searchText?.trim()){
         conditions.push({
          user: { _or: [{given_name: { _ilike: `%${this.searchText}%`}},{family_name: { _ilike: `%${this.searchText}%`}}] }
        })
      }
      conditions.push(...defaultConditions);
      return {
        offset: this.paginationConfig.page * this.paginationConfig.limit - this.paginationConfig.limit,
        limit: this.paginationConfig.limit,
        companyId: this.company.id,
        where: {
          _and: conditions,
        },
        totalActiveWhere: {
          _and: [
            { posting_id: { _eq: this.postingId } },
            { is_cancelled: { _eq: false } }
          ]
        }
      };
    };

    get loading(): boolean {
      return this.$apollo.queries.applications.loading;
    }

  get empty(): boolean {
    const applicants = sessionStorage.getItem("isApplicants");
    if (applicants && applicants.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  get isData(): boolean {
    if (!this.applications) {
      return false;
    }

    return this.applications.length > 0;
  }

    get hasNeededData(): boolean {
      return !!this.applications && !this.loading;
    }

    get emptyListPlaceholder(): string {
      const defaultMessage = 'The job posing has no applications yet'
      switch(true) {
        case this.approved:
          return 'The job posting has no approved applicants yet';
        case this.declined:
          return 'The job posting has no declined applicants yet';
        case this.review:
          return 'The job posting has no applicants under review yet';
        case this.cancelled:
          return 'The job posting has no withdrawn applications';
      }
      return defaultMessage;
    }

    async refetchApplications(): Promise<void>{
      await this.$apollo.queries.applications.refetch();
      this.$emit('applicationCollectionUpdated');
    }

    get approvedExternalContractors(): Application[]{
      if (!this.applications) {
        return [];
      }
      return this.applications
        .filter((application: Application) => {
          return application.status === ApplicantStatus.APPROVED && !belongsToCompany(application.user);
        });
    }

    get approvedExternalContractorExists(): boolean{
      return Boolean(this.approvedExternalContractors.length);
    }

    get companyMembersToRequest(): Application[] {
      if (!this.applications) {
        return [];
      }

    return this.applications
      .filter((application: Application) => {
        const approved = application.status === ApplicantStatus.APPROVED;
        const companyMember = belongsToCompany(application.user);
        const contract = application.user.contracts[0];
        const noManagerConnection = !contract?.managers?.[0];
        return approved && companyMember && noManagerConnection;
      });
    }

    get companyMemberToRequestExists(): boolean {
      return Boolean(this.companyMembersToRequest.length);
    }

    get applicantsForCurrentRole(): Application[] {
      return this.isAdmin
        ? this.approvedExternalContractors
        : [...this.approvedExternalContractors, ...this.companyMembersToRequest];
    }

    async handleInviteAllContractors(): Promise<void> {
      this.processing = true;
      try {
        const userObjects = this.applicantsForCurrentRole.map((applicant: Application) => {
          return {
            user_id: applicant.user.id
          };
        });
        await inviteContractors({
          users: userObjects,
          companyId: this.company.id,
          companyBusinessName: this.company.business_name || "",
          invitedByUserId: this.currentUser.id
        });
        this.$apollo.queries.applications.refetch();
      } catch(err) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(err.message));
      } finally {
        this.processing = false;
      }
    }
  }
